import { Component, ChangeDetectorRef, ViewChild } from '@angular/core';

// Calendar option
import { DateSelectArg, EventApi } from '@fullcalendar/core';
import { CalendarOptions, EventClickArg } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';

import { UntypedFormGroup } from '@angular/forms';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { CalendarModalService } from 'src/app/core/services/modal-services/calendar-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { CalendarListService } from 'src/app/core/services/list-services/calendar-list.service';
import { BaseListComponent } from 'src/app/shared/list-views/base-list/base-list.component';
import { DomSanitizer } from '@angular/platform-browser';
import { OpenModalService } from 'src/app/core/services/modal-services/open-modal.service';
import { PdfViewerModalService } from 'src/app/core/services/modal-services/pdf-viewer-modal.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { CalendarEventModel } from 'src/app/core/models/calendar/calendar.model';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { AttendeeModel } from 'src/app/core/models/calendar/attendee.model';


@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})

/**
 * Calendar Component
 */

export class CalendarComponent extends BaseListComponent {

  // bread crumb items
  breadCrumbItems!: Array<{}>;
  // calendar
  calendarEvents!: any[];
  editEvent: any;
  formEditData!: UntypedFormGroup;
  newEventDate: any;
  category!: any[];

  protected override searchPlaceHolderText: string = "";

  currentEvents: EventApi[] = [];

  selectedModelsArray: AttendeeModel[] = [];
  emailsToSearch: string [] = []
  eventDateRange: any; 

  // Calendar click Event
  formData!: UntypedFormGroup;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected calendarModalService: CalendarModalService,
    protected calendarListService: CalendarListService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override pdfModalService: PdfViewerModalService,
    protected override authMyFileService: AuthMyfileService,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override openModalService: OpenModalService,
  ) {
    super(myFileApiService, sanitizer, pdfModalService, authMyFileService, toasterNotificationService, openModalService);
  }

  @ViewChild('calendar') calendarComponent: FullCalendarComponent | undefined;

  calendarVisible = true;
  calendarOptions: CalendarOptions = {
    plugins: [
      interactionPlugin,
      dayGridPlugin,
      timeGridPlugin,
      listPlugin,
    ],
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
    },
    initialView: 'dayGridMonth',
    weekends: true,
    editable: true,
    selectable: true,
    selectMirror: true,
    dayMaxEvents: true,
    select: this.handleDateSelect.bind(this),
    eventClick: this.handleEventClick.bind(this),
    eventsSet: this.handleEvents.bind(this)
  };

  override ngOnInit(): void {
    this.listItemsObservable = this.calendarListService.resultItems$;
    this.total = this.calendarListService.total$;
    this.isLoading = this.calendarListService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.isLoadingVal = true;
      } else {
        this.isLoadingVal = false;
      }
    });
    this.unsubscribe.push(subscr);

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
      this.updateCalendarEvents();
    });
    this.unsubscribe.push(subscr2);

    this.calendarListService.startIndex = 1;
  }

  ngAfterViewInit(): void {
    this.updateCalendarEvents();
  }

  override ngOnDestroy(): void {
    this.calendarListService.clearListService();
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  updateCalendarEvents() {
    if (this.calendarComponent) {
      let calendarApi = this.calendarComponent.getApi();
      if (calendarApi) {
        calendarApi.removeAllEvents();
        this.listItems.forEach((event: CalendarEventModel) => {
          calendarApi.addEvent({
            id: event.id,
            title: event.title,
            start: event.start,
            end: event.end,
            description: event.description,
            createdById: event.createdById,
            location: event.location,
            className: event.category + ' ' + 'text-white',
            allDay: event.allDayEvent,
            attendees: event.attendees
          });
        });
      }
    }
  }

  newEvent() {
    var dateSelect: any = {
      allDay: false,
      start: undefined,
      end: undefined,
    }
    this.handleDateSelect(dateSelect);
  }

  handleDateSelect(selectInfo: DateSelectArg) {
    var calendarEvent: CalendarEventModel = new CalendarEventModel;
    calendarEvent.date.from = selectInfo.start;
    calendarEvent.date.to = selectInfo.end;
    calendarEvent.allDayEvent = false;
    this.calendarModalService.openModal(calendarEvent);
    var sub = this.calendarModalService.modelChanged.subscribe((result: CalendarEventModel | undefined) => {
      if (result) {
        this.calendarListService.startIndex=1;
        this.updateCalendarEvents()
      }
      sub.unsubscribe();
    })
  }

  handleEventClick(clickInfo: EventClickArg) {
    this.editEvent = clickInfo.event;
    var calendarEvent: CalendarEventModel = new CalendarEventModel();

    calendarEvent.id = clickInfo.event.id;
    calendarEvent.createdById = clickInfo.event.extendedProps['createdById'];
    calendarEvent.date.from = clickInfo.event.start;
    calendarEvent.date.to = clickInfo.event.end;
    calendarEvent.title = clickInfo.event.title;
    calendarEvent.category = clickInfo.event.classNames[0];
    calendarEvent.location = clickInfo.event.extendedProps['location'];
    calendarEvent.description = clickInfo.event.extendedProps['description'];
    calendarEvent.allDayEvent = clickInfo.event.allDay;
    calendarEvent.attendees = clickInfo.event.extendedProps['attendees'];

    this.calendarModalService.openModal(calendarEvent);
    var sub = this.calendarModalService.modelChanged.subscribe((result: CalendarEventModel | undefined) => {
      if (result) {
        this.calendarListService.startIndex=1;
        this.updateCalendarEvents();
      }
      sub.unsubscribe();
    })

  }

  handleEvents(events: EventApi[]) {
    this.currentEvents = events;
    this.changeDetector.detectChanges();
  }

  attendeeSearch(searchArray: any){
    this.emailsToSearch = [];
    searchArray.forEach((attendeeModel: AttendeeModel) => {
      if(attendeeModel.email){
        this.emailsToSearch.push(attendeeModel.email); 
      }
    });
    this.emailsToSearch.push(this.authMyFileService.currentUserContextValue?.email!);
    this.calendarListService.attendeeSearch = this.emailsToSearch; 
  }

  clearDate() {
    this.eventDateRange = undefined;
    this.calendarListService.from = undefined;
    this.calendarListService.to = undefined;
    this.calendarListService.updateDate(); 
  }

  triggerDateSearch(event:any){
    if(event.selectedDates.length == 2){
      this.calendarListService.from = event.selectedDates[0];
      this.calendarListService.to = event.selectedDates[1]; 
      this.calendarListService.updateDate(); 
    }
  }
}